import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export interface IOnChangeFormFieldActionParams {
    name: string,
    value: string,
    oldDetails: any
}
class OnChangeFormFieldAction extends BaseAction<void, IOnChangeFormFieldActionParams> {
    override async run(): Promise<void> {
        try {
            const { name, value, oldDetails } = this.params!
            if (name && value) {                
                updateRecoilState("requestCorporateAccountDetailsAtom", {
                    ...oldDetails,
                    [name]: value
                })
            }

        } catch (error: any) {
            console.error("Error fetching Cities :", error);
        }
        finally {

        }
    }
}

export const onChangeFormFieldAction = new OnChangeFormFieldAction()


